import { useEffect } from "react"
import { useMemberActionTracking } from "#/services/memberActionTracking/useMemberActionTracking"
import { MemberActions } from "#/services/memberActionTracking/memberActions"
import { getActiveFiltersCount, ProviderFinderParam } from "#/pages/provider-finder/utils/providerFinderSearchUrl"
import { useGetLocationDetails } from "#/pages/provider-finder/hooks/useGetLocationDetails"
import { ProviderType } from "#/pages/provider-finder/utils/parentIdMapping"

export function useProviderFinderViewedEvent(
  params: URLSearchParams,
  searchLocation: string,
  providerTypeSearched: ProviderType,
  providerCount: number,
  view: "map" | "list",
  page = 1
) {
  const { mutate: trackMemberAction } = useMemberActionTracking()
  const { data: locationDetails, isFetching: isLocationDetailsFetching } = useGetLocationDetails(searchLocation)

  useEffect(() => {
    if (isLocationDetailsFetching) return

    const activeFilters = getActiveFiltersCount(params)

    trackMemberAction({
      memberActionTaken: params.get(ProviderFinderParam.Keyword)
        ? MemberActions.PROVIDER_FINDER_KEYWORD_SEARCH_RESULT_VIEWED
        : MemberActions.PROVIDER_FINDER_TYPE_SEARCH_RESULT_VIEWED,
      metaData: {
        providerType: providerTypeSearched,
        latitude: Number(params.get(ProviderFinderParam.Latitude)),
        longitude: Number(params.get(ProviderFinderParam.Longitude)),
        view,
        searchDistanceInKm: params.get(ProviderFinderParam.RadiusInKm)
          ? Number(params.get(ProviderFinderParam.RadiusInKm))
          : "anywhereInTheCountry",
        totalNumberOfResults: providerCount,
        currentPage: page,
        keyword: params.get(ProviderFinderParam.Keyword) ?? undefined,
        city: locationDetails?.city,
        administrativeLevels: locationDetails?.administrativeLevels,
        activeFilters: activeFilters
      }
    })
  }, [
    params,
    providerCount,
    providerTypeSearched,
    trackMemberAction,
    page,
    locationDetails,
    isLocationDetailsFetching,
    view
  ])
}
